export default {
  items: [],
  pagination: {},
  size: 50,
  isBusy: false,
  form: {},
};
